/* libs */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

/* components */
import { URL } from "../../../constants";
import formWrapper from "../../shared/Form";
import { TextInput, FileInput, ThemePicker, TopicsPicker, CheckBox } from "../../shared/Forms";

const AppForm = (props) => {
	const { submitForm, user } = props;
	return (
		<React.Fragment>
			<TextInput field="name" id="name" placeholder="Name" autoComplete="off" />
			<TextInput field="key" id="key" placeholder="App Key" autoComplete="off" />
			<ThemePicker field="primaryThemeId" id="primaryThemeId" placeholder="Primary Theme" />
			<FileInput field="loadingContentUrl" id="loadingContentUrl" placeholder="Loading Page Image" />
			<TopicsPicker
				field="firstVisitTopics"
				id="firstVisitTopics"
				placeholder="Topics on First Visit"
				helperText="Automatically subscribed-to topics"
			/>
			<TextInput
				field="privacyPolicy"
				id="privacyPolicy"
				placeholder="Privacy Policy"
				autocomplete="off"
				isRequired={true}
				helperText="A link to your app's privacy policy"
				validationRegex={URL}
			/>
			<TextInput
				field="terms"
				id="terms"
				placeholder="Terms of Services"
				autocomplete="off"
				isRequired={true}
				helperText="A link to your app's terms of service"
				validationRegex={URL}
			/>
			{user.user && user.user.globalRole && (
				<CheckBox label="Labeled 'Event App By Brushfire' (Not Verris)" field="isEventApp" id="isEventApp" />
			)}


			<div className="btn btn-primary grow" onClick={() => submitForm()}>
				Update App
			</div>
		</React.Fragment>
	);
};

AppForm.propTypes = {
	submitForm: PropTypes.func,
};

const mapStateToProps = state => ({
	user: state.user
});

export default connect(mapStateToProps)(formWrapper(AppForm));
